/* eslint-disable import/prefer-default-export */
/* eslint-disable camelcase */
import React from "react"
import { useSelector } from "react-redux"

import { TYPE_A, TYPE_B } from "const"
import { SilType } from "client/utils"
import { StoreType, LangType } from "client/store"
import { InsufficientData, NotCompliant } from "client/components"

interface SilWrapperProps {
    data: string
}
const SilWrapper = ({ data }: SilWrapperProps) => {
    const lang = useSelector((state: StoreType) => state.system.lang)
    return (
        <span>
            {`${data} ${lang.capable}`}
        </span>
    )
}

interface Iec_61508_1998 {
    type: SilType
    sff: string | number | boolean
    lang: LangType
    silOnly?: boolean
    textError?: boolean
}
export const iec_61508_1998_device = (props: Iec_61508_1998) => {
    const { type, lang, silOnly, textError } = props
    const sff = typeof props.sff === "string" ? parseFloat(props.sff) : props.sff
    if (sff === false || sff === null) return textError ? lang.insufficientData : <InsufficientData />

    if (type === TYPE_A) {
        if (sff < 0.6) return silOnly ? lang.sil_1 : <SilWrapper data={lang.sil_1} />
        if (sff >= 0.6 && sff < 0.9) return silOnly ? lang.sil_2 : <SilWrapper data={lang.sil_2} />
        if (sff >= 0.9) return silOnly ? lang.sil_3 : <SilWrapper data={lang.sil_3} />
        return textError ? lang.insufficientData : <InsufficientData />
    }

    if (type === TYPE_B) {
        if (sff < 0.6) return textError ? lang.notCompliant : <NotCompliant />
        if (sff >= 0.6 && sff < 0.9) return silOnly ? lang.sil_1 : <SilWrapper data={lang.sil_1} />
        if (sff >= 0.9 && sff <= 0.99) return silOnly ? lang.sil_2 : <SilWrapper data={lang.sil_2} />
        if (sff > 0.99) return silOnly ? lang.sil_3 : <SilWrapper data={lang.sil_3} />
        return textError ? lang.insufficientData : <InsufficientData />
    }
    return textError ? lang.insufficientData : <InsufficientData />
}
